/**
 * Работа со строкой `brands_trusted` закупера/1С, которая кодирует ОДНОВРЕМЕННО
 * два списка через один разделитель «/»:
 *  - доверенные бренды (искать только у них) — записываются как есть: `NARVA`;
 *  - исключаемые бренды — с префиксом «!»: `!MAHLE`.
 * Пример: `NARVA/OSRAM/!MAHLE` — искать у NARVA/OSRAM, исключить MAHLE.
 * Спецсимвол «*» (все остальные) при разборе относим к доверенным как есть.
 */
export interface SplitBrands {
  trusted: string[];
  excluded: string[];
}

export function splitBrands(combined: string): SplitBrands {
  const entries = combined
    .split("/")
    .map((s) => s.trim())
    .filter(Boolean);
  const trusted: string[] = [];
  const excluded: string[] = [];
  for (const entry of entries) {
    if (entry.startsWith("!")) {
      const name = entry.slice(1).trim();
      if (name) excluded.push(name);
    } else {
      trusted.push(entry);
    }
  }
  return { trusted, excluded };
}

export function mergeBrands(trusted: string[], excluded: string[]): string {
  return [...trusted, ...excluded.map((b) => `!${b}`)].join("/");
}
